import { render } from "./modalPresentar.vue?vue&type=template&id=08c81d39"
import script from "./modalPresentar.vue?vue&type=script&lang=js"
export * from "./modalPresentar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__